// import pageTransitions from './animations/transitions';
// import * as basicScroll from 'basicscroll'
import utils from './utils';
import filesList from './files-list';
import nav from './nav';
import sliders from './sliders';
import cf7 from './cf7';
import switcherContent from './switcher-content';
import tippy from 'tippy.js';
import Calculator from './calculator';
import customSelect from './custom-select';
import findInsurance from './find-insurance';
import video from './video';
import contactForm from './contact-form';
import faq from './faq';
import productsFiltering from './_products-filtering';
import loadMorePosts from './load-more-posts';
import table from './table';
import searchFilter from './search-filter';
import './accessibility';
import $ from "jquery";
import dataLay from "./dataLayer";
import dynamicContent from './dynamic-content';
import information from './information';
import productForm from './product-form';
import compensaPopup from "./compensa-popup";
import questionnaire from "./questionnaire";
import communicationFrontend from "./communication-frontend";


export default class App {
	constructor() {
		this.initDev(); // tests and shit
		this.initBody(); // runs on initialize & after barba
	}

	initBody() {
		sliders();

	}

	initCore() {
		// pageTransitions(); // barbaajs
		// nav.hamburger();
		nav.cookieForCompanyPage();
		nav.base();
		nav.search();
		nav.accordion();
		nav.scrollTop();
		nav.showMore();
		nav.stickyHeader();
		information.init();
		filesList.init();
		console.log('core');
		switcherContent.init();
		switcherContent.switchBySpecificId();
		tippy('[data-tippy-content]', {
			theme: 'light',
			arrow: true
		});
		const appCalculator = new Calculator();
		cf7.init();
		productForm.init();
		questionnaire.init();
		customSelect.customSelect('.custom-select');
		cf7.complaintFormAppendSelect();
		cf7.setPlaceholders();
		findInsurance.init();
		video.init();
		video.block();
		contactForm.init();
		faq.init();
		productsFiltering.init();
		loadMorePosts.init();
		table.init();
		loadMorePosts.loadMoreResults();
		searchFilter.init();
		dataLay.productButton();
		dataLay.singleButton();
		dataLay.formEvents();
		dynamicContent.renderModalOnClick();
		this.setPayUPayments();
		this.openAccordionOnAnchor();
		compensaPopup.init();
		productForm.activeProductTab();
		communicationFrontend.init();
	}

	initDev() {
		utils.clone('[data-clone]');
		console.clear()
	}

	setPayUPayments() {
		const locationHash = window.location.hash;

		if (locationHash === '#platnosci-z-payu') {
			const getNavigationTab = document.querySelector('.contact-with-faq-block .content-switcher__navigation-item:nth-of-type(2)');
			if (getNavigationTab) getNavigationTab.click();

			const getFaqCategoryContainer = document.querySelector('.faq__categories-list');

			const payUPayments = [...getFaqCategoryContainer.children].filter(a => a.getAttribute('href') === '#platnosci-pytania-i-odpowiedzi');

			if (payUPayments[0]) payUPayments[0].click();
		}
	}

	openAccordionOnAnchor() {
		const locationHash = window.location.hash;

		if (locationHash) {
			const accordionContainer = document.querySelector(`${locationHash}`);

			if (accordionContainer) {
				const accordion = accordionContainer.querySelector('.js-accordion-title');

				accordion?.click();
			}
		}
	}
}


function LoadApp() {
	const app = new App();
	app.initCore(); // runs on initialize
}

if (document.readyState === 'loading') {
	document.addEventListener('DOMContentLoaded', LoadApp);
} else {
	LoadApp();
}

$('.cookies-settings').attr('id', 'cookie-law-info-again');
